import type { CityData } from "./cities-data.types";

export const CITY_CATALOG_B: CityData[] = [
  // Rajasthan
  {
    slug: "udaipur",
    name: "Udaipur",
    name_hi: "उदयपुर",
    state: "Rajasthan",
    latitude: 24.5854,
    longitude: 73.7125,
    timezone: "Asia/Kolkata",
    regional_note:
      "Udaipur, the historic capital of the Mewar kingdom, follows Indian Standard Time. The 17th-century Jagdish Temple near the City Palace, the Ambamata Temple, and Eklingji — the ruling deity of Mewar, about 22 km north — anchor the city's Hindu worship. Udaipur observes the Mewar (Gangaur) Festival, its own grand Jagannath Rath Yatra, and Hariyali Amavasya with particular devotion. Panchang, choghadiya, and rahu kaal here are computed for Udaipur's exact coordinates beside Lake Pichola.",
    local_festivals: ["Mewar Festival (Gangaur)", "Jagannath Rath Yatra", "Hariyali Amavasya"],
  },
  {
    slug: "kota",
    name: "Kota",
    name_hi: "कोटा",
    state: "Rajasthan",
    latitude: 25.2138,
    longitude: 75.8648,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kota, the spiritual heart of Rajasthan's Hadoti region, follows Indian Standard Time. The ancient Kansua Shiv Mandir within the city, with the riverside Geparnath and Garadia Mahadev Shiva shrines along the Chambal nearby, are its principal places of worship. Kota is famed for its 25-day Dussehra Mela — among India's largest, tracing to 1723 CE — alongside Gangaur and Teej. Panchang, choghadiya, and rahu kaal timings are computed for Kota's exact coordinates on the Chambal River.",
    local_festivals: ["Kota Dussehra Mela", "Gangaur", "Teej"],
  },
  {
    slug: "ajmer",
    name: "Ajmer",
    name_hi: "अजमेर",
    state: "Rajasthan",
    latitude: 26.4499,
    longitude: 74.6399,
    timezone: "Asia/Kolkata",
    regional_note:
      "Ajmer, one of Rajasthan's oldest cities and the historic Chauhan capital, follows Indian Standard Time. The marble Sai Baba Temple at Ajay Nagar and the hilltop Samai Mata Temple are prominent Hindu shrines within the city, set below the 8th-century Taragarh Fort. Ajmer observes Gangaur, Teej, and Diwali, while the famed Pushkar Fair unfolds nearby at Kartik Purnima. Panchang, choghadiya, and rahu kaal timings are computed for Ajmer's exact coordinates in the Aravalli foothills.",
    local_festivals: ["Gangaur", "Teej", "Pushkar Fair (Kartik Purnima)"],
  },
  {
    slug: "bikaner",
    name: "Bikaner",
    name_hi: "बीकानेर",
    state: "Rajasthan",
    latitude: 28.0229,
    longitude: 73.3119,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bikaner, founded in 1488 CE by Rao Bika of the Rathore dynasty, follows Indian Standard Time. The Laxminath Temple — one of the city's oldest, dedicated to Vishnu and Lakshmi — and the frescoed 15th-century Bhandasar temple sit at its historic core. Janmashtami and Diwali are kept with devotion at Laxminath Temple, and the city's Camel Festival each January is a regional landmark. Panchang, choghadiya, and rahu kaal timings are computed for Bikaner's exact coordinates in the Thar Desert.",
    local_festivals: ["Bikaner Camel Festival", "Janmashtami", "Gangaur"],
  },
  {
    slug: "alwar",
    name: "Alwar",
    name_hi: "अलवर",
    state: "Rajasthan",
    latitude: 27.5531,
    longitude: 76.6346,
    timezone: "Asia/Kolkata",
    regional_note:
      "Alwar, a gateway to Rajputana at the northern edge of the Aravallis, follows Indian Standard Time. The Jagannath Temple in the old city — known for its distinctive annual Rath Yatra — and the Moti Doongri Ganesha temple, thronged every Thursday, are the city's leading Hindu shrines. Alwar observes its Rath Yatra, Ganesh Chaturthi, and Gangaur, alongside the February Alwar Utsav. Panchang, choghadiya, and rahu kaal timings are computed for Alwar's exact coordinates below the Bala Qila fort.",
    local_festivals: ["Rath Yatra (Alwar)", "Ganesh Chaturthi", "Gangaur"],
  },
  {
    slug: "bharatpur",
    name: "Bharatpur",
    name_hi: "भरतपुर",
    state: "Rajasthan",
    latitude: 27.2152,
    longitude: 77.503,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bharatpur, set in the Braj cultural region associated with Lord Krishna, follows Indian Standard Time. The 19th-century Ganga Mandir in the city's heart, the Banke Bihari Krishna temple, and the Laxman Mandir are its principal Hindu landmarks. As a Braj-region town, Bharatpur celebrates Janmashtami and the Braj Holi festival — with Raslila performances — alongside Dussehra and Gangaur. Panchang, choghadiya, and rahu kaal timings are computed for Bharatpur's exact coordinates in eastern Rajasthan.",
    local_festivals: ["Braj Holi", "Janmashtami", "Dussehra"],
  },
  {
    slug: "sikar",
    name: "Sikar",
    name_hi: "सीकर",
    state: "Rajasthan",
    latitude: 27.6094,
    longitude: 75.1399,
    timezone: "Asia/Kolkata",
    regional_note:
      "Sikar, the commercial heart of Rajasthan's Shekhawati region, follows Indian Standard Time. The 10th-century Harshnath Shiva temple in the Aravalli Hills and the renowned Khatu Shyam Ji temple — a major Krishna pilgrimage site in the district — draw devotees from across the state. Sikar observes Makar Sankranti, Gangaur, and Teej, with the great Phalguna Mela held at Khatu Shyam. Panchang, choghadiya, and rahu kaal timings are computed for Sikar's exact coordinates in the Shekhawati region.",
    local_festivals: ["Makar Sankranti", "Gangaur", "Phalguna Mela (Khatu Shyam)"],
  },
  {
    slug: "bhilwara",
    name: "Bhilwara",
    name_hi: "भीलवाड़ा",
    state: "Rajasthan",
    latitude: 25.3536,
    longitude: 74.6299,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bhilwara, Rajasthan's textile city with continuous Hindu settlement for nearly a millennium, follows Indian Standard Time. The 11th-century Bada Mandir (Krishna-Radha) at its historic core, the hillside Harni Mahadev Shiva temple, and the Kyara ke Balaji Hanuman shrine anchor local worship. Bhilwara is known for its distinctive 18-day Gangaur procession, alongside Teej and Maha Shivaratri. Panchang, choghadiya, and rahu kaal timings are computed for Bhilwara's exact coordinates in the Mewar region.",
    local_festivals: ["Gangaur", "Teej", "Maha Shivaratri"],
  },
  {
    slug: "nathdwara",
    name: "Nathdwara",
    name_hi: "नाथद्वारा",
    state: "Rajasthan",
    latitude: 24.9347,
    longitude: 73.822,
    timezone: "Asia/Kolkata",
    sunrise_range: "6:05–7:25 AM",
    regional_note:
      "Nathdwara, home to the Shrinathji Temple (Pushtimarg's holiest shrine), draws 30,000–50,000 pilgrims daily. The temple operates on a precise daily schedule (darshan in 8 sevas) governed entirely by the Panchanga. Every ritual is coordinated with the Hindu almanac. Vallabhacharya's Pushtimarg tradition has the most elaborate festival calendar in all of Vaishnavism — muhurta is sacred law here.",
    local_festivals: ["Janmashtami", "Holi (Phoolon ki Holi)", "Annakut"],
  },
  // Uttar Pradesh
  {
    slug: "mathura",
    name: "Mathura",
    name_hi: "मथुरा",
    state: "Uttar Pradesh",
    latitude: 27.4924,
    longitude: 77.6737,
    timezone: "Asia/Kolkata",
    sunrise_range: "5:28–7:05 AM",
    regional_note:
      "Mathura, birthplace of Lord Krishna and one of India's seven sacred cities, sits on the Yamuna River. The Krishna Janmabhoomi Temple marks the exact birth site. Mathura and neighboring Vrindavan together form the Braj pilgrimage circuit — Holi here (Lathmar Holi in Barsana, Phoolon wali Holi in Vrindavan) is the world's most vibrant. Every festival follows exact Panchanga timing, especially Janmashtami midnight celebrations.",
    local_festivals: ["Janmashtami", "Holi (Lathmar)", "Radhashtami"],
  },
  {
    slug: "noida",
    name: "Noida",
    name_hi: "नोएडा",
    state: "Uttar Pradesh",
    latitude: 28.5355,
    longitude: 77.391,
    timezone: "Asia/Kolkata",
    regional_note:
      "Noida, a planned city in the Delhi-NCR, follows Indian Standard Time. The ISKCON Sri Sri Radha-Govind temple in Sector 33, the Jagannath Temple replica in Sector 34, and the Kali Bari in Sector 26 are its principal devotional centres. Noida celebrates Janmashtami at ISKCON, the Odia community's Rath Yatra, and Holi and Diwali city-wide. By Ramayana tradition, nearby Bishrakh is held to be Ravana's birthplace. Panchang, choghadiya, and rahu kaal timings are computed for Noida's exact coordinates.",
    local_festivals: ["Janmashtami", "Rath Yatra", "Gaur Purnima"],
  },
  {
    slug: "gorakhpur",
    name: "Gorakhpur",
    name_hi: "गोरखपुर",
    state: "Uttar Pradesh",
    latitude: 26.7606,
    longitude: 83.3732,
    timezone: "Asia/Kolkata",
    regional_note:
      "Gorakhpur, the global seat of the Nath Sampradaya, follows Indian Standard Time. The 52-acre Gorakhnath Temple — after which the city is named, with its ever-burning flame — the devotional Geeta Vatika, and the renowned Gita Press anchor its spiritual life. Gorakhpur's Khichdi Mela on Makar Sankranti draws pilgrims from Nepal and across the border, alongside Maha Shivratri and Janmashtami. Panchang, choghadiya, and rahu kaal timings are computed for Gorakhpur's exact coordinates in eastern Uttar Pradesh.",
    local_festivals: ["Khichdi Mela (Makar Sankranti)", "Maha Shivratri", "Janmashtami"],
  },
  {
    slug: "bareilly",
    name: "Bareilly",
    name_hi: "बरेली",
    state: "Uttar Pradesh",
    latitude: 28.367,
    longitude: 79.4304,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bareilly, known as Nath Nagri or the City of Shiva, follows Indian Standard Time. Seven ancient Shiva temples — including Alakhnath, Trivati Nath, and Dhopeshwarnath — are distributed across the city, their positions believed to form a protective sacred boundary. On Maha Shivratri all seven host night-long worship, transforming the city, while Navratri and Dussehra fill its localities with Ramlila. Panchang, choghadiya, and rahu kaal timings are computed for Bareilly's exact coordinates in the Rohilkhand region.",
    local_festivals: ["Maha Shivratri", "Navratri", "Nariyawal Mela"],
  },
  {
    slug: "aligarh",
    name: "Aligarh",
    name_hi: "अलीगढ़",
    state: "Uttar Pradesh",
    latitude: 27.8974,
    longitude: 78.088,
    timezone: "Asia/Kolkata",
    regional_note:
      "Aligarh, lying within the Braj region linked to Lord Krishna, follows Indian Standard Time. The ancient Khereshwar Shiva temple, revered for its near-invisible shivlinga, and the unusual Gilaharaj Ji temple — depicting Hanuman in squirrel form — are notable local shrines. Aligarh observes Maha Shivratri at Khereshwar, Janmashtami, and Navratri across the city. Panchang, choghadiya, and rahu kaal timings are computed for Aligarh's exact coordinates in western Uttar Pradesh.",
    local_festivals: ["Maha Shivratri", "Janmashtami", "Navratri"],
  },
  {
    slug: "moradabad",
    name: "Moradabad",
    name_hi: "मुरादाबाद",
    state: "Uttar Pradesh",
    latitude: 28.8386,
    longitude: 78.7733,
    timezone: "Asia/Kolkata",
    regional_note:
      "Moradabad, renowned as India's Brass City for its intricately crafted metalwork exported worldwide, is home to the Prachin Shri Kali Mata Mandir in Lal Bagh, believed to be over 400 years old and founded by Naga sadhus, and the 200-year-old Hathi Wala Mandir on Ram Ganga Road. Bade Hanuman Ji Mandir is another prominent devotional centre in the city. Navratri, Diwali, Durga Puja, and Chhath Puja draw large congregations each year. Panchang, choghadiya, and rahu kaal timings are computed for Moradabad's exact coordinates.",
    local_festivals: ["Navratri", "Durga Puja", "Chhath Puja"],
  },
  {
    slug: "jhansi",
    name: "Jhansi",
    name_hi: "झाँसी",
    state: "Uttar Pradesh",
    latitude: 25.4484,
    longitude: 78.5685,
    timezone: "Asia/Kolkata",
    regional_note:
      "Mahalakshmi Temple in Jhansi, built in the late 18th century by Maratha Subedar Shivrao Bhau on the banks of Lakshmi Tal, served as the Kul Devi shrine of the Maharajas of Jhansi and was regularly visited by Rani Lakshmibai herself. The nearby Ganesh Temple in Ganesh Bazaar is where Rani Lakshmibai wed Raja Gangadharrao in 1842. Navratri at the Mahalakshmi Temple, Ganesh Chaturthi, and Diwali are major local observances across this Bundelkhand city. Panchang, choghadiya, and rahu kaal timings are computed for Jhansi's exact coordinates.",
    local_festivals: ["Navratri", "Ganesh Chaturthi", "Diwali"],
  },
  {
    slug: "saharanpur",
    name: "Saharanpur",
    name_hi: "सहारनपुर",
    state: "Uttar Pradesh",
    latitude: 29.968,
    longitude: 77.551,
    timezone: "Asia/Kolkata",
    regional_note:
      "Shri Bhuteshwar Mahadev Temple in Saharanpur city, dedicated to a self-manifested Swayambhu Shivling, draws thousands of Kanwariyas during Shravan who carry Ganga water from Haridwar for Jalabhishek, and large crowds at Mahashivratri. The district's most celebrated pilgrimage is Shakambhari Devi Shakti Peeth, about 40 km north in the Shivalik hills, one of the 51 Shakti Peethas. Navratri at Shakambhari Devi, Mahashivratri, and the Shravan Kanwar Yatra define the city's ritual calendar. Panchang, choghadiya, and rahu kaal timings are computed for Saharanpur's exact coordinates.",
    local_festivals: ["Navratri", "Mahashivratri", "Shravan Kanwar Yatra"],
  },
  {
    slug: "firozabad",
    name: "Firozabad",
    name_hi: "फ़िरोज़ाबाद",
    state: "Uttar Pradesh",
    latitude: 27.1592,
    longitude: 78.3957,
    timezone: "Asia/Kolkata",
    regional_note:
      "Firozabad, celebrated as India's glass-bangle capital producing over 40 percent of the nation's bangles, holds deep religious character through the Vaishno Devi Temple about 4 km on the Tundla route, where Navadurga fairs gather pilgrims annually, and the ancient Shri Hanuman Temple established during the Maratha period. The city lies within the Braj cultural region, lending a Vaishnava character to local festivity. Navratri, Janmashtami, Diwali, and Holi are enthusiastically observed. Panchang, choghadiya, and rahu kaal timings are computed for Firozabad's exact coordinates.",
    local_festivals: ["Navratri", "Janmashtami", "Holi"],
  },
  {
    slug: "muzaffarnagar",
    name: "Muzaffarnagar",
    name_hi: "मुजफ्फरनगर",
    state: "Uttar Pradesh",
    latitude: 29.4727,
    longitude: 77.7085,
    timezone: "Asia/Kolkata",
    regional_note:
      "Shiv Chowk at the heart of Muzaffarnagar, anchored by a towering Shiva statue, is the city's most recognisable landmark, while Durga Dham houses an 80-foot Durga idol and Bhairon Ka Mandir shelters eleven Shivalingas. Shukratal about 28 km from the city on the sacred Ganga is where sage Shukdev is believed to have narrated the Shrimad Bhagavata Purana to King Parikshit, marked today by the Akshayavat tree and a 72-foot Hanuman statue. Kartik Purnima bathing at Shukratal, Navratri, and Diwali are the major observances. Panchang, choghadiya, and rahu kaal timings are computed for Muzaffarnagar's exact coordinates.",
    local_festivals: ["Kartik Purnima Ganga Snan (Shukratal)", "Navratri", "Mahashivratri"],
  },
  {
    slug: "hapur",
    name: "Hapur",
    name_hi: "हापुड़",
    state: "Uttar Pradesh",
    latitude: 28.7301,
    longitude: 77.7757,
    timezone: "Asia/Kolkata",
    regional_note:
      "Chandi Mandir in Kishanganj, Hapur, an ancient Shaktipeeth with a five-foot black stone idol of Devi Chandi, performs aarti five times daily and draws lakhs of devotees during Navratri, when 52 ritual bhogs are offered over nine days. Shiv Bari Mandir in a nearby village is believed to be 700 years old and renowned for its self-rising Shivlinga. Brijghat on the Ganga about 35 km away hosts a massive Kartik Purnima mela at which over five lakh pilgrims take a sacred dip each year. Panchang, choghadiya, and rahu kaal timings are computed for Hapur's exact coordinates.",
    local_festivals: ["Navratri", "Kartik Purnima Ganga Mela (Brijghat)", "Mahashivratri"],
  },
  // Bihar
  {
    slug: "gaya",
    name: "Gaya",
    name_hi: "गया",
    state: "Bihar",
    latitude: 24.7914,
    longitude: 85.0002,
    timezone: "Asia/Kolkata",
    regional_note:
      "Gaya, revered as Moksha Bhoomi, follows Indian Standard Time. The Vishnupad Temple on the Falgu River — enshrining a footprint of Lord Vishnu, rebuilt in 1787 by Ahilyabai Holkar — and the Mangla Gauri Shakti Peetha are its holiest sites. Gaya is the pre-eminent place in Hinduism for pind-daan: its 16-day Pitru Paksha Mela draws pilgrims performing ancestral rites believed to free seven generations and relieve Pitru Dosha. Panchang, choghadiya, and rahu kaal timings are computed for Gaya's exact coordinates.",
    local_festivals: ["Pitru Paksha Mela", "Navratri", "Chhath Puja"],
  },
  {
    slug: "muzaffarpur",
    name: "Muzaffarpur",
    name_hi: "मुजफ्फरपुर",
    state: "Bihar",
    latitude: 26.1209,
    longitude: 85.3647,
    timezone: "Asia/Kolkata",
    regional_note:
      "Muzaffarpur, set in the ancient Videha region of King Janaka, follows Indian Standard Time. Baba Garibnath Dham — one of Bihar's oldest Shiva temples, called the Deoghar of Bihar — and the city's Kali Mata Temple are its foremost shrines. Muzaffarpur observes Chhath Puja with elaborate rituals at the Bagmati ghats, the month-long Shravan Mela, and Maha Shivratri at Garibnath Dham. Panchang, choghadiya, and rahu kaal timings are computed for Muzaffarpur's exact coordinates in northern Bihar.",
    local_festivals: ["Chhath Puja", "Maha Shivratri", "Shravan Mela"],
  },
  {
    slug: "bhagalpur",
    name: "Bhagalpur",
    name_hi: "भागलपुर",
    state: "Bihar",
    latitude: 25.2425,
    longitude: 87.0033,
    timezone: "Asia/Kolkata",
    regional_note:
      "Budhanath Mandir, an ancient Shiva temple on the Ganga's bank in Bhagalpur, enshrines a Swayambhu Shivalinga counted among the 108 Nath temples of India. Shravan Somvar begins well before sunrise with ritual bathing and milk abhishek, drawing pilgrims across Bihar and Jharkhand. Ajgaivinath Dham in Sultanganj, about 25 km west, sits on a rock island in the Ganga, and each Shravani Mela sees lakhs fill kanwars with holy water to carry on foot to Baba Baidyanath at Deoghar. Bhagalpur's Vikramshila Mahotsav celebrates its ancient university legacy. Panchang, choghadiya, and rahu kaal timings are computed for Bhagalpur's exact coordinates.",
    local_festivals: ["Shravani Mela", "Maha Shivaratri", "Chhath Puja"],
  },
  {
    slug: "darbhanga",
    name: "Darbhanga",
    name_hi: "दरभंगा",
    state: "Bihar",
    latitude: 26.1542,
    longitude: 85.8918,
    timezone: "Asia/Kolkata",
    regional_note:
      "Shyama Mai Temple, founded by Maharaja Kameshwar Singh in 1933 on the cremation pyre of Maharaja Rameshwar Singh, is Darbhanga's most distinctive sacred site: a six-temple complex around a central kund where Kali is worshipped by both Vedic and Tantric rites, with Navratri seeing its largest fair. As the cultural capital of Mithilanchal, Darbhanga is inseparable from poet Vidyapati's devotional legacy, his Maithili songs sung at every Hindu rite here. Madhushravani and Chhath Puja are the region's most cherished observances. Panchang, choghadiya, and rahu kaal timings are computed for Darbhanga's exact coordinates.",
    local_festivals: ["Chhath Puja", "Madhushravani", "Navratri"],
  },
  {
    slug: "bodh-gaya",
    name: "Bodh Gaya",
    name_hi: "बोधगया",
    state: "Bihar",
    latitude: 24.6951,
    longitude: 84.9915,
    timezone: "Asia/Kolkata",
    sunrise_range: "5:05–6:35 AM",
    regional_note:
      "Bodh Gaya, the holiest site in Buddhism, is where Siddhartha Gautama attained enlightenment under the Bodhi Tree. The Mahabodhi Temple (UNESCO World Heritage Site) marks the exact spot. For Hindu pilgrims, the nearby Vishnupad Temple (Lord Vishnu's footprint) and the Falgu River are sites for Pitru Tarpan (ancestor rites). Every auspicious day on the Panchanga draws lakhs of pilgrims for ritual bathing and ancestral offerings.",
    local_festivals: ["Buddha Purnima", "Pitru Paksha", "Chhath Puja"],
  },
  {
    slug: "purnea",
    name: "Purnia",
    name_hi: "पूर्णिया",
    state: "Bihar",
    latitude: 25.7771,
    longitude: 87.4753,
    timezone: "Asia/Kolkata",
    regional_note:
      "Purnia takes its very name from Puran Devi Mandir, an ancient temple 5 km from the city centre where Goddess Puran Devi, revered as a composite of nine goddesses and a form of Kali, has been worshipped since the Mughal era. The adjacent Mata Durga Temple, about 250 years old, is another important shrine. The city sits at the confluence of Mithilanchal and Seemanchal cultures, with Chhath Puja observed along the Kosi and Mahananda ghats. Navratri draws the largest pilgrimage crowds to Puran Devi. Panchang, choghadiya, and rahu kaal timings are computed for Purnia's exact coordinates.",
    local_festivals: ["Chhath Puja", "Navratri", "Durga Puja"],
  },
  {
    slug: "begusarai",
    name: "Begusarai",
    name_hi: "बेगूसराय",
    state: "Bihar",
    latitude: 25.4182,
    longitude: 86.1272,
    timezone: "Asia/Kolkata",
    regional_note:
      "Simaria Dham, a sacred Ganga ghat about 12 km from Begusarai on the river's north bank, hosts one of Bihar's most venerable Kalpvas traditions, believed established by King Janaka of Mithila. Each Kartik month, the month-long Simaria Mela draws hundreds of thousands for sacred bathing and a Ganga Maha Aarti that rivals Varanasi in grandeur. Naulakha Mandir in Bishanpur village features a nine-pinnacled shikhara housing Radha-Krishna, Shiva, and Durga. Jaimangla Garh Temple on Kanwar Lake is the city's Navratri focal point. Panchang, choghadiya, and rahu kaal timings are computed for Begusarai's exact coordinates.",
    local_festivals: ["Chhath Puja", "Kartik Kalpvas Mela", "Navratri"],
  },
  // Jharkhand
  {
    slug: "jamshedpur",
    name: "Jamshedpur",
    name_hi: "जमशेदपुर",
    state: "Jharkhand",
    latitude: 22.8046,
    longitude: 86.2029,
    timezone: "Asia/Kolkata",
    regional_note:
      "Jamshedpur, India's first planned steel city, is cradled between the Subarnarekha and Kharkai rivers whose confluence at Domuhani Ghat transforms into a luminous arena of ritual during Chhath Puja, the city's most celebrated festival. The Bhuvaneshwari Temple atop Telco Hill, built in 1978 in Dravidian style with a 64-foot Rajagopuram, overlooks the township and draws devotees year-round. The Sakchi Hanuman Mandir in the original township is a longstanding local shrine. Durga Puja and Ganesh Puja are observed with great fervour. Panchang, choghadiya, and rahu kaal timings are computed for Jamshedpur's exact coordinates.",
    local_festivals: ["Chhath Puja", "Durga Puja", "Ganesh Puja"],
  },
  {
    slug: "dhanbad",
    name: "Dhanbad",
    name_hi: "धनबाद",
    state: "Jharkhand",
    latitude: 23.7957,
    longitude: 86.4304,
    timezone: "Asia/Kolkata",
    regional_note:
      "Dhanbad, India's Coal Capital, anchors its devotional life at the 800-year-old Lillori Sthan Mandir on the Katri riverbank, where Goddess Lillori, a form of Kali, is venerated as the neighbourhood's protector, and Kali Puja here draws thousands during Diwali season. The ancient Pandweshwar Mahadev temple in Nirsa block honours the region's deep Shaiva tradition. Maa Kalyaneshwari, a revered 500-year-old Shakti shrine, lies about 35 km away across the Barakar River on the West Bengal border. Navratri and Rath Yatra are also widely observed. Panchang, choghadiya, and rahu kaal timings are computed for Dhanbad's exact coordinates.",
    local_festivals: ["Kali Puja", "Navratri", "Rath Yatra"],
  },
  {
    slug: "bokaro",
    name: "Bokaro",
    name_hi: "बोकारो",
    state: "Jharkhand",
    latitude: 23.6693,
    longitude: 86.1511,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bokaro Steel City's most distinctive temple is the Jagannath Mandir in Sector 4, built in 1992 faithfully replicating the Kalinga-style Pancharatha architecture of the Puri shrine, and its Rath Yatra is the city's signature annual event. Chhath Puja draws the largest community gathering each year, with Bokaro's City Park lake serving as a key venue for Sun-worship rituals. Durga Puja sees hundreds of pandals across the planned sectors with elaborate replicas of famous temples. Navratri and Saraswati Puja are widely celebrated. Panchang, choghadiya, and rahu kaal timings are computed for Bokaro's exact coordinates.",
    local_festivals: ["Rath Yatra", "Chhath Puja", "Durga Puja"],
  },
  // West Bengal
  {
    slug: "howrah",
    name: "Howrah",
    name_hi: "हावड़ा",
    state: "West Bengal",
    latitude: 22.5958,
    longitude: 88.2636,
    timezone: "Asia/Kolkata",
    regional_note:
      "Belur Math, the global headquarters of the Ramakrishna Mission founded by Swami Vivekananda in 1898, stands on the Hooghly's west bank in Belur within Howrah district. Its 16-hectare campus enshrines temples to Sri Ramakrishna, Sarada Devi, and Vivekananda, with architecture blending Hindu, Buddhist, and Christian motifs. Jagaddhatri Puja has been observed in Shibpur since 1713, making Howrah one of Bengal's oldest celebration centres. Durga Puja, Kali Puja, and Poila Boishakh fill the city's calendar. Panchang, choghadiya, and rahu kaal timings are computed for Howrah's exact coordinates.",
    local_festivals: ["Durga Puja", "Jagaddhatri Puja", "Kali Puja"],
  },
  {
    slug: "asansol",
    name: "Asansol",
    name_hi: "आसनसोल",
    state: "West Bengal",
    latitude: 23.6834,
    longitude: 86.982,
    timezone: "Asia/Kolkata",
    regional_note:
      "Asansol's oldest shrine, Ghagar Buri Chandi Mata Temple, established in 1620, enshrines Goddess Chandi in a self-manifested Pindi form and draws devotees every Tuesday and Saturday. The Rash Purnima annual fair and a country fair each 15 January are its signature observances. The Kalyaneshwari Temple, a 500-year-old Shakti Peetha where Goddess Sati's forearm is said to have fallen, lies roughly 13 km away on the Barakar River near Maithon. Durga Puja and Kali Puja transform this industrial city each October. Panchang, choghadiya, and rahu kaal timings are computed for Asansol's exact coordinates.",
    local_festivals: ["Durga Puja", "Kali Puja", "Rash Purnima Mela"],
  },
  {
    slug: "durgapur",
    name: "Durgapur",
    name_hi: "दुर्गापुर",
    state: "West Bengal",
    latitude: 23.48,
    longitude: 87.32,
    timezone: "Asia/Kolkata",
    regional_note:
      "Rarheshwar Shiv Mandir, built around 1200 CE in Nagara style using sandstone and laterite, is an ASI-protected Monument of National Importance within Durgapur's Arrah locality. Its ancient Shivalinga draws one to two lakh devotees in the Shravan month. The ISKCON Durgapur temple and Bhiringi Kali Mandir of Benachity add living devotional anchors to this Steel City. Durga Puja is celebrated with creative themed pandals across the city each October. Panchang, choghadiya, and rahu kaal timings are computed for Durgapur's exact coordinates.",
    local_festivals: ["Durga Puja", "Maha Shivaratri", "Kali Puja"],
  },
  {
    slug: "siliguri",
    name: "Siliguri",
    name_hi: "सिलीगुड़ी",
    state: "West Bengal",
    latitude: 26.7271,
    longitude: 88.3953,
    timezone: "Asia/Kolkata",
    regional_note:
      "ISKCON Siliguri's Sri Sri Radha Madhav Sundar Mandir anchors the city's spiritual life with a hexagonal platform design and marble carvings, conducting aartis from early morning Mangal Aarti through evening Sandhya Aarti. As the gateway to Darjeeling, Sikkim, Bhutan, and the Northeast, Siliguri hosts a uniquely multi-faith heritage, and Janmashtami here draws some of West Bengal's largest ISKCON gatherings. The Jaimangla Gadh Chandi Mangala temple on Kanwar Lake is an important Shakti site, with Kali Puja and Navratri drawing regional pilgrims. Panchang, choghadiya, and rahu kaal timings are computed for Siliguri's exact coordinates.",
    local_festivals: ["Janmashtami", "Kali Puja", "Durga Puja"],
  },
  {
    slug: "bardhaman",
    name: "Bardhaman",
    name_hi: "बर्दवान",
    state: "West Bengal",
    latitude: 23.2324,
    longitude: 87.8615,
    timezone: "Asia/Kolkata",
    regional_note:
      "Rising from twin sacred ponds in Nababhat, Bardhaman's famed 108 Shiva Temples complex comprises 108 identically styled aat-chala shrines each housing a black Shivalinga, flanked by 108 matching bells rung by pilgrims at auspicious hours. The 18th-century Sarbamangala Temple, built by Maharaja Kirtichand Rai and dedicated to a form of Devi Durga, is another prime site in the city. The Rajbari Durga Puja preserves the centuries-old tradition of worshipping Devi through a painted image rather than an idol. Panchang, choghadiya, and rahu kaal timings are computed for Bardhaman's exact coordinates.",
    local_festivals: ["Durga Puja", "Maha Shivaratri", "Kali Puja"],
  },
  {
    slug: "malda",
    name: "Malda",
    name_hi: "मालदा",
    state: "West Bengal",
    latitude: 25.0108,
    longitude: 88.1434,
    timezone: "Asia/Kolkata",
    regional_note:
      "Ramkeli, roughly 14 km south of Malda town near the ruins of medieval Gaur, is Bengal's foremost Vaishnava pilgrimage: Sri Chaitanya Mahaprabhu visited in 1515 CE, inspiring Rupa and Sanatana Goswami to renounce royal life for devotion. The site's ISKCON Ramkeli temple and eight sacred kunds mark the spot. Each Jaistha Sankranti, the week-long Ramkeli Mela draws thousands for naam-kirtan. The Gaur-Pandua ruins nearby preserve Bengal Sultanate-era stone carvings that include repurposed Hindu motifs. Panchang, choghadiya, and rahu kaal timings are computed for Malda's exact coordinates.",
    local_festivals: ["Ramkeli Mela", "Durga Puja", "Janmashtami"],
  },
  // Odisha
  {
    slug: "cuttack",
    name: "Cuttack",
    name_hi: "कटक",
    state: "Odisha",
    latitude: 20.4625,
    longitude: 85.883,
    timezone: "Asia/Kolkata",
    regional_note:
      "Maa Katak Chandi, the living guardian goddess of Cuttack's Silver City, presides from her Mahanadi-bank temple and is venerated through a distinctive 16-day Durga Puja spanning Krishna Ashtami to Vijayadashami, far longer than the standard five days observed elsewhere in Odisha. Dhabaleswar, a revered Shiva island-temple on the Mahanadi, lies roughly 20 km from the city. Kali Puja and Rath Yatra complete the city's devotional calendar. Panchang, choghadiya, and rahu kaal timings are computed for Cuttack's exact coordinates.",
    local_festivals: ["Durga Puja (16-day)", "Kali Puja", "Bali Yatra"],
  },
  {
    slug: "rourkela",
    name: "Rourkela",
    name_hi: "राउरकेला",
    state: "Odisha",
    latitude: 22.2604,
    longitude: 84.8536,
    timezone: "Asia/Kolkata",
    regional_note:
      "Vedvyas Dham, at the sacred confluence of the Koel, Sankha, and Saraswati rivers where they unite to form the Brahmani, is Rourkela's most revered pilgrimage site, and tradition holds that sage Maharshi Vedvyas composed the Mahabharata here. The complex shelters Shiva, Radha Krishna, Jagannath, and Saraswati shrines. Hanuman Vatika in the city features a 75-foot Hanuman statue alongside twelve Jyotirlingas. Mahashivaratri and Kartika Purnima draw large pilgrim gatherings to Vedvyas. Panchang, choghadiya, and rahu kaal timings are computed for Rourkela's exact coordinates.",
    local_festivals: ["Mahashivaratri", "Kartika Purnima", "Durga Puja"],
  },
  {
    slug: "berhampur",
    name: "Berhampur",
    name_hi: "बेरहामपुर",
    state: "Odisha",
    latitude: 19.315,
    longitude: 84.7941,
    timezone: "Asia/Kolkata",
    regional_note:
      "Berhampur, Odisha's Silk City, is famed for the biennial Thakurani Yatra, a month-long Chaitra festival in which Maa Budhi Thakurani, the city's protective goddess, is carried in grand procession to her parent's home, drawing lakhs of devotees from across Ganjam district. The Budhi Thakurani temple in the city is the heart of this unique tradition rooted in the Dera weaver community. Maa Tara Tarini, one of India's four primary Adi Shakti Peethas, stands on a hilltop roughly 28 km away at Purushottampur. Dola Yatra and Danda Yatra are other cherished festivals. Panchang, choghadiya, and rahu kaal timings are computed for Berhampur's exact coordinates.",
    local_festivals: ["Thakurani Yatra (biennial)", "Dola Yatra", "Danda Yatra"],
  },
  {
    slug: "puri",
    name: "Puri",
    name_hi: "पुरी",
    state: "Odisha",
    latitude: 19.8134,
    longitude: 85.8315,
    timezone: "Asia/Kolkata",
    sunrise_range: "5:05–6:20 AM",
    regional_note:
      "Puri, one of India's four sacred Dhams (Char Dham), is home to the Jagannath Temple — one of the wealthiest and most visited temples in India. Rath Yatra (Chariot Festival) draws 1–2 million pilgrims annually. The temple's 56-bhog (food offerings) and daily rituals are timed precisely to the Panchanga. Puri is also a center for Odia classical music and Chhau dance. The beach is sacred for sunrise rituals.",
    local_festivals: ["Rath Yatra", "Snana Yatra", "Kartik Purnima"],
  },
  {
    slug: "sambalpur",
    name: "Sambalpur",
    name_hi: "संबलपुर",
    state: "Odisha",
    latitude: 21.4669,
    longitude: 83.9812,
    timezone: "Asia/Kolkata",
    regional_note:
      "Sambalpur's spiritual identity centres on Maa Samaleswari, the Shakti goddess enthroned on the banks of the Mahanadi and revered as Jagat Janani, Mother of the Universe, across all of western Odisha. The 400-year-old Sital Sasthi Yatra, a grand week-long carnival in May and June celebrating the divine marriage of Lord Shiva and Parvati, draws devotees from multiple states and is Sambalpur's most distinctive festival. Nuakhai, when new harvest is first offered to the goddess, is the region's most important social festival. Panchang, choghadiya, and rahu kaal timings are computed for Sambalpur's exact coordinates.",
    local_festivals: ["Sital Sasthi Yatra", "Nuakhai", "Durga Puja"],
  },
  // Madhya Pradesh
  {
    slug: "rewa",
    name: "Rewa",
    name_hi: "रीवा",
    state: "Madhya Pradesh",
    latitude: 24.5362,
    longitude: 81.2996,
    timezone: "Asia/Kolkata",
    regional_note:
      "The Mahamrityunjaya Temple inside Rewa Fort, installed by King Bhav Singh Ju Deo, anchors the spiritual heart of this Baghelkhand capital. The Chirahula Hanuman Mandir on Gurh Road is beloved for Tuesday and Saturday prayers. Govindgarh, Rewa's Mini Vrindavan with its Ram Govind, Panchmukhi, and Shiva temples, lies about 13 km away. Navratri, the Mahamrityunjaya Festival on Basant Panchami, Vindhya Mahotsava, Malmaas Mela, and Diwali are the city's landmark celebrations. Panchang, choghadiya, and rahu kaal timings are computed for Rewa's exact coordinates.",
    local_festivals: [
      "Mahamrityunjaya Festival (Basant Panchami)",
      "Vindhya Mahotsava",
      "Malmaas Mela",
    ],
  },
  {
    slug: "satna",
    name: "Satna",
    name_hi: "सतना",
    state: "Madhya Pradesh",
    latitude: 24.5866,
    longitude: 80.8322,
    timezone: "Asia/Kolkata",
    regional_note:
      "Satna's own Venkatesh Mandir hosts Guru Purnima, Janmashtami, and Sharad Purnima. The Golamath Shiva Temple, built in the Kalchuri period of the 10th to 11th century, stands near the city on Deviji Road. The district's great pilgrimages lie at some distance: Maa Sharda Devi Temple at Maihar about 40 km away atop Trikut hill, a Shakti Peetha reached by 1,064 steps, and Chitrakoot about 78 km away, the forest shrine of Lord Ram. Ram Navami, Navratri, Deep Daan on the Mandakini, Janmashtami, and Makar Sankranti define the sacred calendar. Panchang, choghadiya, and rahu kaal timings are computed for Satna's exact coordinates.",
    local_festivals: ["Ram Navami", "Deep Daan (Chitrakoot)", "Navratri"],
  },
  {
    slug: "sagar",
    name: "Sagar",
    name_hi: "सागर",
    state: "Madhya Pradesh",
    latitude: 23.8388,
    longitude: 78.7378,
    timezone: "Asia/Kolkata",
    regional_note:
      "Vitthal Mandir and Vrindavan Bagh temple on the banks of Lakha Banjara Lake, the 400-acre lake at the city's centre, form Sagar's lakeside devotional hub, and a Ganga Aarti is held at Chakra Ghat every Monday evening. The Garhpehra Hanuman Temple, in the ancient Dangi-era fort about 15 km north, draws daily pilgrims. Harsiddhi Devi Mandir at Rangir about 34 km away sees great fairs in Ashvin and Chaitra. The Bundeli-culture city celebrates Navratri, Shivaratri, Holi, Diwali, and its civic Gour Jayanti procession. Panchang, choghadiya, and rahu kaal timings are computed for Sagar's exact coordinates.",
    local_festivals: ["Gour Jayanti (civic procession)", "Navratri", "Maha Shivaratri"],
  },
  {
    slug: "dewas",
    name: "Dewas",
    name_hi: "देवास",
    state: "Madhya Pradesh",
    latitude: 22.9623,
    longitude: 76.068,
    timezone: "Asia/Kolkata",
    regional_note:
      "Dewas takes its name from Devi Vashini, abode of the goddess, and its identity is inseparable from the Tekri, a 300-foot conical hill at the city's heart where twin shrines honour Badi Mata (Tulja Bhavani) and Choti Mata (Chamunda Devi), a Shakta Peetha linked to the legend of Sati's blood. Some 500 steps, a ropeway, and a stone stairway lead up. Author E.M. Forster immortalised the hill in The Hill of Devi. Navaratri in both Chaitra and Ashvin and the distinctly Malwa celebration of Rang Panchami draw lakhs of pilgrims. Panchang, choghadiya, and rahu kaal timings are computed for Dewas's exact coordinates.",
    local_festivals: ["Navratri (Tekri fair)", "Rang Panchami", "Maha Shivaratri"],
  },
  {
    slug: "ratlam",
    name: "Ratlam",
    name_hi: "रतलाम",
    state: "Madhya Pradesh",
    latitude: 23.3315,
    longitude: 75.0367,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kalika Mata Mandir in Anand Colony, Ratlam's most celebrated temple dedicated to the goddess Shakti, hosts an annual Navratri fair renowned across Malwa for its Garba, the city's cultural signature. Mahalaxmi Temple draws devotees in large numbers during Diwali. Further afield, the Kedareshwar Mahadev Temple about 20 km away at Sailana, carved from a single igneous rock cliff, and the 11th-century Bilapkeshwara (Virupaksha) Shiva shrine about 18 km away at Bilpank, are district highlights. Navratri, Maha Shivaratri, Diwali, Holi, and Karva Chauth mark the city's festival calendar. Panchang, choghadiya, and rahu kaal timings are computed for Ratlam's exact coordinates.",
    local_festivals: ["Navratri (Garba at Kalika Mata)", "Maha Shivaratri", "Karva Chauth"],
  },
  {
    slug: "singrauli",
    name: "Singrauli",
    name_hi: "सिंगरौली",
    state: "Madhya Pradesh",
    latitude: 24.1997,
    longitude: 82.6689,
    timezone: "Asia/Kolkata",
    regional_note:
      "Singrauli is Madhya Pradesh's principal energy hub, home to NTPC's Vindhyachal Super Thermal Power Station and Northern Coalfields, and verifiable in-city temple coverage is limited. The Shri Hanuman Temple at Jhingurdah is a locally maintained Hanuman shrine on the MP-UP border, its stairway crossing both states. The Mada Caves, 7th to 8th-century rock-cut shrines with Ganesh, Shankar, and Vivah Madas, lie about 32 km away in Mada tehsil; the Sita Kuti and Chaturbhuj Temple at Padri about 30 km away are district pilgrimage sites. Navratri, Maha Shivaratri, and Makar Sankranti are the main Hindu observances. Panchang, choghadiya, and rahu kaal timings are computed for Singrauli's exact coordinates.",
    local_festivals: ["Navratri", "Maha Shivaratri", "Makar Sankranti (Chaturbhuj Temple, Padri)"],
  },
  // Chhattisgarh
  {
    slug: "bhilai",
    name: "Bhilai",
    name_hi: "भिलाई",
    state: "Chhattisgarh",
    latitude: 21.2167,
    longitude: 81.4333,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bhilai, Chhattisgarh's Steel City of India, was built from 1959 with Soviet collaboration and is known as Mini India for its pan-Indian workforce, a diversity reflected in the range of festivals observed here. Maa Jagdamba Mandir is a prominent local shrine drawing large crowds every Navratri. The ancient 13th-century Mahadev temple at Deobaloda village, a protected ASI monument roughly 15 km from Bhilai Nagar, is the district's most historic Shiva shrine and hosts a Mahashivaratri fair. Hareli and Durga Puja are celebrated with regional fervour. Panchang, choghadiya, and rahu kaal timings are computed for Bhilai's exact coordinates.",
    local_festivals: ["Navratri", "Hareli", "Mahashivaratri"],
  },
  {
    slug: "bilaspur-cg",
    name: "Bilaspur",
    name_hi: "बिलासपुर",
    state: "Chhattisgarh",
    latitude: 22.0797,
    longitude: 82.1391,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bilaspur's most revered pilgrimage is Maa Mahamaya Devi Mandir at Ratanpur, roughly 25 km from the city, one of India's 52 Shakti Peethas, dedicated to the Kosaleswari goddess who presides over the ancient Daksin Kosal region now called Chhattisgarh. The Navratri Jyotikalash lit here draws pilgrims from across the state. Within the district, the 5th to 8th-century Deorani-Jethani temple complex at Tala village preserves remarkable Kalachuri-era sculpture. The seasonal Shiva shrine at Khutaghat Dam adds a unique devotional character. Panchang, choghadiya, and rahu kaal timings are computed for Bilaspur's exact coordinates.",
    local_festivals: ["Navratri", "Mahashivaratri", "Hareli"],
  },
  {
    slug: "durg",
    name: "Durg",
    name_hi: "दुर्ग",
    state: "Chhattisgarh",
    latitude: 21.1924,
    longitude: 81.2841,
    timezone: "Asia/Kolkata",
    regional_note:
      "Durg district's most celebrated ancient shrine is the 13th-century Mahadev temple at Deobaloda village, a protected ASI monument built on a single stone slab in Nagara style during the Kalachuri era, lying approximately 22 km from Durg city and hosting a Mahashivaratri fair attended by devotees from across the region. In the city, the Shiv Mandir and the Hanuman temple in the city centre are principal worship sites. Navratri, Mahashivaratri, and Hareli, Chhattisgarh's first festival of the agrarian year, are the most widely observed celebrations. Panchang, choghadiya, and rahu kaal timings are computed for Durg's exact coordinates.",
    local_festivals: ["Mahashivaratri", "Navratri", "Hareli"],
  },
  {
    slug: "korba",
    name: "Korba",
    name_hi: "कोरबा",
    state: "Chhattisgarh",
    latitude: 22.3595,
    longitude: 82.7501,
    timezone: "Asia/Kolkata",
    regional_note:
      "Korba, Chhattisgarh's Power Capital of India, shelters the Maa Sarvamangala Mandir, a temple to Goddess Durga on the banks of the Hasdeo River around 5 km from the city centre, ringed by Trilokinath Mandir and Kali Mandir. Navratri and Dussehra bring the largest congregations to Sarvamangala, while Karma and Hareli reflect the district's deep tribal agricultural traditions. The Kankeshwar Mahadev temple at Kanki is a noted Shiva shrine within the district. Panchang, choghadiya, and rahu kaal timings are computed for Korba's exact coordinates.",
    local_festivals: ["Navratri", "Dussehra", "Karma"],
  },
  // Maharashtra
  {
    slug: "aurangabad",
    name: "Aurangabad (Sambhajinagar)",
    name_hi: "औरंगाबाद",
    state: "Maharashtra",
    latitude: 19.8762,
    longitude: 75.3433,
    timezone: "Asia/Kolkata",
    regional_note:
      "Aurangabad, now officially Chhatrapati Sambhajinagar, serves as the gateway to the 12th Jyotirlinga, Grishneshwar Temple at Verul village about 30 km away near Ellora's UNESCO-listed caves. Within the city, the Jai Mahakali Mata Mandir draws devotees year-round, while the 17th-century Bibi ka Maqbara anchors the historic skyline. Shravan Mondays and Maha Shivaratri prompt mass pilgrimages to Grishneshwar, while Ganesh Chaturthi and Navratri are celebrated across city neighbourhoods. Panchang, choghadiya, and rahu kaal timings are computed for Aurangabad's exact coordinates.",
    local_festivals: [
      "Maha Shivaratri (Grishneshwar pilgrimage)",
      "Shravan Somvar",
      "Ganesh Chaturthi",
    ],
  },
  {
    slug: "solapur",
    name: "Solapur",
    name_hi: "सोलापुर",
    state: "Maharashtra",
    latitude: 17.6599,
    longitude: 75.9064,
    timezone: "Asia/Kolkata",
    regional_note:
      "Solapur's spiritual life centres on the Siddheshwar Temple, where 12th-century Lingayat saint Siddharameshwar attained samadhi in 1167 CE. The complex enshrines 68 Shiva lingams he installed and sits beside a sacred lake. Each year on Makar Sankranti, the 15-day Gadda Yatra fair draws over a lakh devotees from Maharashtra, Karnataka, and Andhra Pradesh, a 900-year-old tradition. Mornings here begin with abhishek during the four Shravan Mondays. Pandharpur, the Varkari heartland, lies about 70 km north. Panchang, choghadiya, and rahu kaal timings are computed for Solapur's exact coordinates.",
    local_festivals: ["Gadda Yatra (Makar Sankranti)", "Shravan Somvar", "Maha Shivaratri"],
  },
  {
    slug: "kolhapur",
    name: "Kolhapur",
    name_hi: "कोल्हापुर",
    state: "Maharashtra",
    latitude: 16.705,
    longitude: 74.2433,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kolhapur is home to the Shri Mahalakshmi (Ambabai) Temple, revered as one of the three-and-a-half Shakti Peethas of the Shakta tradition. Twice yearly, the Kirnotsav draws pilgrims when the setting sun's rays illuminate the goddess's idol directly, a phenomenon unique to this temple. The Rathotsav chariot procession, Lalita Panchami, Margashirsha Guruvar, and Navratri are marked with elaborate rituals, and during Navratri the temple is lit throughout the night. The city gives its name to Kolhapuri chappals and the famed Kolhapuri cuisine. Panchang, choghadiya, and rahu kaal timings are computed for Kolhapur's exact coordinates.",
    local_festivals: ["Kirnotsav", "Rathotsav (chariot procession)", "Navratri"],
  },
  {
    slug: "amravati",
    name: "Amravati",
    name_hi: "अमरावती",
    state: "Maharashtra",
    latitude: 20.932,
    longitude: 77.7523,
    timezone: "Asia/Kolkata",
    regional_note:
      "The Shri Ambadevi Temple, over a thousand years old and the city's namesake, anchors Amravati's identity as a temple town of Vidarbha. Dedicated to Goddess Ambadevi, a form of Durga, it is paired with the adjacent Ekvira Devi Temple consecrated in 1660 CE. Hindu tradition holds that Lord Krishna carried Rukmini away from this sacred precinct before her forced marriage to Shishupala. Navratri draws thousands across both shrines, with dandiya and all-night bhajan, while Maha Shivaratri and Ganesh Chaturthi are celebrated widely in the city. Panchang, choghadiya, and rahu kaal timings are computed for Amravati's exact coordinates.",
    local_festivals: ["Navratri (Ambadevi-Ekvira)", "Maha Shivaratri", "Ganesh Chaturthi"],
  },
  {
    slug: "nanded",
    name: "Nanded",
    name_hi: "नांदेड़",
    state: "Maharashtra",
    latitude: 19.1383,
    longitude: 77.321,
    timezone: "Asia/Kolkata",
    regional_note:
      "Nanded's defining shrine is Takhat Sachkhand Sri Hazur Abchalnagar Sahib, one of Sikhism's five Takhts, marking where Guru Gobind Singh Ji spent his final days in 1708 and declared the Guru Granth Sahib the eternal Guru. For Hindu devotees, the Kaleshwar Mandir on the Godavari bank at Vishnupuri about 10 km away offers 13th-century South-Indian architecture and draws pilgrims through Shravan and Maha Shivaratri. The Mahur pilgrimage site of Goddess Renuka Devi about 120 km away hosts a major Navratri-Dasara fair. Panchang, choghadiya, and rahu kaal timings are computed for Nanded's exact coordinates.",
    local_festivals: [
      "Guru Gobind Singh Ji Gurpurab",
      "Maha Shivaratri (Kaleshwar)",
      "Shravan Somvar",
    ],
  },
  {
    slug: "sangli",
    name: "Sangli",
    name_hi: "सांगली",
    state: "Maharashtra",
    latitude: 16.8524,
    longitude: 74.5815,
    timezone: "Asia/Kolkata",
    regional_note:
      "At the heart of Sangli stands the Shri Ganpati Temple, built in the early 19th century by Chintamanrao Patwardhan on the Krishna River's eastern bank, with Lord Ganesha enshrined here as the presiding deity of the former Sangli principality. The Narsinhwadi Datta Mandir, dedicated to Lord Dattatreya at the confluence of the Krishna and Panchganga rivers, lies about 22 km away. Sangli is Maharashtra's turmeric capital, and Ganesh Chaturthi is celebrated across the city for 11 days. Navratri, Datta Jayanti, and Shravan observances round out the calendar. Panchang, choghadiya, and rahu kaal timings are computed for Sangli's exact coordinates.",
    local_festivals: ["Ganesh Chaturthi (11-day)", "Datta Jayanti", "Navratri"],
  },
  {
    slug: "jalgaon",
    name: "Jalgaon",
    name_hi: "जळगांव",
    state: "Maharashtra",
    latitude: 21.0077,
    longitude: 75.5626,
    timezone: "Asia/Kolkata",
    regional_note:
      "Known across Maharashtra as the Banana Capital, Jalgaon houses two prominent city temples: the Omkareshwar Mandir, a revered Shiva shrine at the centre of the city, and the Ecchapurti Ganesh Temple at Navi Peth, believed to fulfil devotees' wishes. Shivratri, Shravan Somvar, and Gokulashtami bring the Omkareshwar Mandir alive with morning rituals and evening aarti. Ganesh Chaturthi at the Ecchapurti temple draws large crowds each Bhadrapad. The Ajanta Caves UNESCO World Heritage Site lies about 55 km away. Panchang, choghadiya, and rahu kaal timings are computed for Jalgaon's exact coordinates.",
    local_festivals: [
      "Maha Shivaratri (Omkareshwar)",
      "Shravan Somvar",
      "Ganesh Chaturthi (Ecchapurti)",
    ],
  },
  {
    slug: "akola",
    name: "Akola",
    name_hi: "अकोला",
    state: "Maharashtra",
    latitude: 20.7002,
    longitude: 77.0082,
    timezone: "Asia/Kolkata",
    regional_note:
      "Inside Akola Fort stands the Raj Rajeshwar Mandir, one of the city's oldest Shiva temples, distinguished by a legendary Shivalinga said to bear a natural crack and believed to be perpetually bathed in sacred water. The Shravan month draws the faithful in kavad processions, culminating on the fourth Monday when a palkhi travels from Gandhigram for a ceremonial abhishek, a tradition unique to Akola. The Salasar Balaji Temple serves Hanuman devotees. Maha Shivaratri, Ganesh Chaturthi, and the Pola harvest festival anchor the civic calendar. Panchang, choghadiya, and rahu kaal timings are computed for Akola's exact coordinates.",
    local_festivals: [
      "Shravan kavad-palkhi procession (Raj Rajeshwar)",
      "Maha Shivaratri",
      "Ganesh Chaturthi",
    ],
  },
  {
    slug: "latur",
    name: "Latur",
    name_hi: "लातूर",
    state: "Maharashtra",
    latitude: 18.4088,
    longitude: 76.5604,
    timezone: "Asia/Kolkata",
    regional_note:
      "The twin Siddheshwar-Ratneshwar Temple complex, built by King Tamradwaj and situated about 2 km from Latur city, is the district's foremost Shaiva pilgrimage site, set within a large stone tank and hosting a major Maha Shivaratri fair each year. The ancient Kharosa Caves about 45 km away, with 6th-century rock-cut shrines bearing Shiva-Parvati and Narasimha sculptures, attest to the region's deep Hindu heritage. Navratri is celebrated at the Jagdamba Mata Temple in Ganj Golai, and morning abhishek draws devotees to Siddheshwar-Ratneshwar throughout Shravan. Panchang, choghadiya, and rahu kaal timings are computed for Latur's exact coordinates.",
    local_festivals: [
      "Maha Shivaratri (Siddheshwar-Ratneshwar fair)",
      "Navratri (Jagdamba Mata)",
      "Shravan Somvar",
    ],
  },
  {
    slug: "shirdi",
    name: "Shirdi",
    name_hi: "शिरडी",
    state: "Maharashtra",
    latitude: 19.7676,
    longitude: 74.4777,
    timezone: "Asia/Kolkata",
    sunrise_range: "6:05–7:20 AM",
    regional_note:
      "Shirdi, home to the Sai Baba Shrine, receives 30,000–100,000 devotees daily — one of the highest-visited pilgrimage sites in the world. Sai Baba's aarti timings (Kakad aarti at 4:30 AM, Dhoop aarti at noon, Shej aarti at 10:30 PM) follow fixed daily schedules but are planned around Panchanga for auspicious dates. Devotees from all faiths visit — the shrine observes both Islamic and Hindu calendars.",
    local_festivals: ["Ram Navami", "Guru Purnima", "Diwali"],
  },
];
